module.exports = __webpack_public_path__ + "src/assets/img/activities_lake.bb76428e.jpg";